export default __webpack_public_path__ + "static/media/warning--low-ground-clearance--g2.3e54bb51.png";